import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgVideoCamera = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M32 6.286v19.428c0 .477-.286.89-.698 1.048a1.014 1.014 0 0 1-.445.095c-.317 0-.571-.127-.794-.35l-7.206-7.174v2.953c0 2.825-2.317 5.143-5.143 5.143H5.143C2.317 27.429 0 25.11 0 22.286V9.714C0 6.89 2.317 4.571 5.143 4.571h12.571c2.826 0 5.143 2.318 5.143 5.143v2.953l7.206-7.175c.223-.222.477-.35.794-.35.159 0 .318.033.445.096.412.159.698.572.698 1.048z" /></svg>;
export default SvgVideoCamera;